import PromotionsReport from "../Features/Shared/Promotions/PromotionsReport";

const Promotions = () => {

    return (
        <div style={{ flex: 1}}>
            <PromotionsReport />
        </div>
    )
};

export default Promotions;